import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { PlansPageTopTab, User } from '@app/models';
import { UserService } from '@app/services';

@Component({
  selector: 'app-documents-count',
  templateUrl: './documents-count.component.html',
  styleUrls: ['./documents-count.component.scss'],
  standalone: false
})
export class DocumentsCountComponent {
  @Input() user!: User;
  @Input() disableIcon = false;

  constructor(
    public userService: UserService,
    private router: Router
  ) {}

  goToPlanPage(): void {
    this.router.navigate(['/perfil/planos'], { fragment: PlansPageTopTab.Plan });
  }
}
